import {Component, OnInit} from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-paritation',
  templateUrl: './paritation.component.html',
  styleUrls: ['./paritation.component.scss']
})
export class ParitationComponent implements OnInit {

  constructor(public coef: CoefService) {
  }

  ngOnInit() {
  }

}
